import React, { useState, useEffect } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import "./App.css";
import { GlobalContext } from "./contexts/GlobalContext";
import { CoazApp } from "coaz-ui";
import client from "./client";
import {
  PiChartLineLight,
  PiGraduationCapLight,
  PiChalkboardTeacherLight,
  PiStudentLight,
} from "react-icons/pi";
import MyStatistics from "./components/MyStatistics";
import Programs from "./components/Programs";
import Students from "./components/Students";
import Teacher from "./components/Teacher";
import Program from "./components/Program"; 
import Cpd from "./components/Cpd"; 
import Student from "./components/Student";
import CpdStudent from "./components/CpdStudent";
import Teach from "./components/Teach";
import TeachTopic from "./components/TeachTopic";
import Topic from "./components/Topic";
import FileResource from "./components/FileResource";

function App() {
  const [userFilter,setUserFilter] = useState({});
  const [loading, setLoading] = useState(false);
  const [version, setVersion] = useState(0);
  const [user, setUser] = useState(null);
  const [menus, setMenus] = useState([]);

  const path = useLocation().pathname;
  const navigate = useNavigate();
  const { getCurrent, logout } = client;



  useEffect(() => {
    if (path.includes("_login")) return;
    if (path === "/") {
      /* navigate("/_statistics"); */
	  navigate("/_student");
      return;
    }
    (async () => {
      const current = await getCurrent();

      if (!current || !current.user) return;
        setUser(current.user);
        
          let mnus = [
            /* { name: "My Statistics", link: "/_statistics", Icon: PiChartLineLight} */
            { name: "Student", link: "/_student", Icon: PiStudentLight },
			{ name: "Teacher", link: "/_teacher", Icon: PiChalkboardTeacherLight },
            { name: "Programs", link: "/_programs", Icon: PiGraduationCapLight },
          ];

          /* const authorities = current.authorities ?? [];
          const hasAuthority = (names) => authorities.some((auth) => names.includes(auth.authority));
          mnus = mnus.filter((menu) => {
            if (menu.link === "/_statistics" || menu.link === "/_enrollments") return hasAuthority(["PROGRAM:ENROLL"]);
            if (menu.link === "/_my_courses") return hasAuthority(["CPD:TEACH"]);
            if (menu.link === "/_programs") return hasAuthority(["PROGRAM:CREATE", "PROGRAM:READ", "PROGRAM:UPDATE", "PROGRAM:DELETE"]);
            return true;
          }); */

          setMenus(mnus);
        })();
  }, [path]);

  return (
    <div className="flex flex-col bg-[url(/public/images/login.jpg)] bg-cover bg-center w-dvw h-dvh overflow-hidden">
      <div className="flex w-full h-full overflow-hidden">
        <GlobalContext.Provider
          value={{
            loading,
            setLoading,
            version,
            setVersion}}
        >
            <Routes>
              <Route
                path="/"
                element={
                  <CoazApp
                    title="CPD"
                    menus={menus}
                    user={user}
                    logoLink="/_student"
                    /* loginLink={`https://auth.coaz.org/_login?successUrl=${window.location.href}`} */
                    loginLink={`https://portal.coaz.org/_login?successUrl=${window.location.href}`}
                    logout={logout}
                  />
                }
              >
                {/* <Route path="_statistics" element={<MyStatistics />} /> */}
                <Route path="_student" element={<Students/>}>
                  <Route path="_program/:programId" element={<Student />}>
                    <Route path="_cpd/:cpdId" element={<CpdStudent />}>
						<Route path="_topic/:topicId/:teacherId" element={<Topic/>}>
							<Route path="_file/:fileId" element={<FileResource/>}/>
						</Route>
					</Route>
                  </Route>
                </Route>
                <Route path="_teacher" element={<Teacher/>}>
					<Route path="_teach/:cpdId" element={<Teach/>}>
						<Route path="_topic/:topicId" element={<TeachTopic/>}>
							<Route path="_file/:fileId" element={<FileResource/>}/>
						</Route>
					</Route>
				</Route>
                <Route path="_programs" element={<Programs />}>
                  <Route path="_program/:programId" element={<Program />}>
                    <Route path="_cpd/:cpdId" element={<Cpd />} />
                  </Route>
                </Route>
              </Route>
            </Routes>

            <nav className="fixed bottom-4 left-4 right-4 z-50 flex sm:hidden justify-around rounded-xl bg-white p-2 shadow-xl pointer-events-auto">
              {menus.map((menu) => (
                <button
                  key={menu.link}
                  type="button"
                  onClick={() => navigate(menu.link)}
                  aria-label={menu.name}
                  className={`flex h-10 w-10 cursor-pointer touch-manipulation items-center justify-center rounded-full ${
                    path === menu.link
                      ? "bg-[rgba(0,175,240,.12)] text-[rgb(0,175,240)]"
                      : "text-[rgb(68,71,70)]"
                  }`}
                >
                  <menu.Icon size={22} />
                </button>
              ))}
            </nav>
          
        </GlobalContext.Provider>
      </div>
    </div>
  );
}

export default App;